'use strict';

import {convertDataVToVue} from '../apply_vue_data_directives.js';

export class Infoblock {
	constructor(component_id) {
		this.id = component_id;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
		this.$edit = this.$root.find(`.js-${this.id}_edit`);
		this.$info_btn = this.$root.find(`.js-${this.id}_info`);
		this.vue_data_vars = {};
		this.vue_method_vars = {};
		this.extras = {};
	}
	init() {
		this.init_mobile_keypad_with_button();
	}
	vue_setup(Vue) {
			this.init_mobile_keypad_with_button();
			
			this.Vue = Vue;
			const ythis = this;

			if (!this.$root) {
				console.error(`Vue JS container not found for ID: ${this.id}`);
				return {};
			}
			let $rootx = document.querySelector(`.js-${this.id}`);
			const template = `${convertDataVToVue($rootx)}`;
			return ythis.Vue.defineComponent({
				delimiters: ['[[', ']]'],
				name: ythis.id,
				template,
				data() {
					return {
						useCase: structuredClone(ythis.vars.data.useCase),
						dialog_id : ythis.vars.dialog_id,
						pf_info_slider:null,
						is_saving: false,
						...ythis.vue_data_vars
					}
				},
				setup() {
					if (ythis.vars.dialog_id) {
						yalwa.mobile.assets_loader().init_component_by_key(ythis.vars.dialog_id);
						//Init
						ythis.$info_btn.on('click', () => {
						
						})
						return {
							...ythis.setup_vars(Vue)
						};
					}
					
				},
				methods : {
					openDialog() {
						jQuery(`.js-${this.dialog_id}`).appendTo('body');
						yalwa.v.component_instances[this.dialog_id].show();
						//Stop Body Scrolling
						jQuery('html').addClass('js-no_scroll');
					},
					closeDialog() {
						jQuery('html').removeClass('js-no_scroll');
						yalwa.v.component_instances[this.dialog_id].hide();
					},
					suffixIconClick(){
						const guideDialog = yalwa.v.component_instances['dialog_vipguidewhy'];
						if (guideDialog) {
							const section_bits = {
								'infoblock_gallery': 1,
								'gallery': 1,
								'infoblock_profile_image': 2,
								'profile_image': 2,
								'infoblock_contact': 4,
								'contact': 4,
								'website': 4,
								'infoblock_website': 4,
								'infoblock_location': 8,
								'location': 8,
								'infoblock_aboutme': 16,
								'aboutme': 16,
								'infoblock_highlight': 32,
								'highlight': 32,
								'highlights': 32,
								'infoblock_services': 64,
								'services': 64,
								'infoblock_businesshours': 128,
								'businesshours': 128,
								'hours': 128,
							};
							const bit = section_bits[this.id]
								|| section_bits[String(this.id || '').replace(/^infoblock_/, '')]
								|| section_bits[String(this.dialog_id || '').replace(/^dialog_/, '')]
								|| null;

							document.dispatchEvent(new CustomEvent('vip_guide_dialog_view', {
								detail: { view: 'checklist', bit: bit }
							}));

							jQuery('.js-dialog_vipguidewhy').appendTo('body');
							guideDialog.show();
							return;
						}

						jQuery('html').addClass('js-no_scroll');
						jQuery(`.js-dialog_infoicon`).appendTo('body');
						yalwa.v.component_instances['dialog_infoicon'].show();
						
						const slide_options = {
							css_prefix:'infocard__',
							timeout:7000,
							container_class: 'js-simple_auto_slide_vipinfo',
							bullets : {container_class:  'js-slider_vipinfo_pagination_container'},
							clickable : false,
						};
						this.pf_info_slider = new yalwa.basics.simple_auto_slide(slide_options);
						this.pf_info_slider.start();
						
						//Mobile
						if (window.innerWidth <= 765) {
							jQuery('.js-slider_vipinfo_pagination_container').appendTo('.js-pagination_header');
						}
					},
					prefixIconClick(){
						jQuery(`.js-dialog_purchasevip`).appendTo('body');
						yalwa.v.component_instances['dialog_purchasevip'].show();
						
					},
					...ythis.vue_method_vars
				},
				...this.extras
			});
	}
	setup_vars(Vue) {}
	init_mobile_keypad_with_button() {
		if (window.visualViewport) {
			window.visualViewport.addEventListener('resize', () => {
				const footer = document.querySelector('.js-bottom_float_above_keypad');
				// Adjust the bottom property based on the keyboard height
				if (footer) {
					const keyboard_height = window.innerHeight - window.visualViewport.height;
					footer.style.bottom = `${keyboard_height}px`;
				}
				
			});
		}
	}
}